import React, {memo} from "react";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "../../../../../../layout/layoutHeader/components/styles";
import StyledToolTip from "../../../../../common/StyledToolTip";
import DispatchDriverIcon from "../../../../../../layout/icons/DispatchDriverIcon";
import { compose } from 'recompose';
class CreateDispatch extends React.Component {
  constructor(props) {
    super(props);
  }

  onCreateDispatch = () => {
    this.props.eventHub.emit("createDispatch");
  };

  render() {
    const { classes, enableDispatchDriver, theme } = this.props;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } ${
          enableDispatchDriver ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={enableDispatchDriver ? this.onCreateDispatch : null}
      >
        <StyledToolTip
          title={
            enableDispatchDriver
              ? "Dispatch Driver"
              : "Dispatch Driver (Disabled)"
          }
        >
          <div>
            <DispatchDriverIcon height={18} width={18} color={theme.iconColor} />
          </div>
        </StyledToolTip>
      </div>
    );
  }
}

export default compose(withStyles(styles), withTheme())(memo(CreateDispatch));
